import type { AreaCatalog } from '../area';
import type { criteria as en } from '../en/criteria';

export const criteria = {
  'criteria.attribute.active': 'Aktiv',
  'criteria.attribute.closed': 'Abschluss',
  'criteria.attribute.level': 'Zustand',
  'criteria.attribute.assignee': 'Zuständig',
  'criteria.attribute.party': 'Beteiligte',
  'criteria.attribute.group': 'Gruppe',
  'criteria.attribute.parent': 'Übergeordnete Aufgabe',
  'criteria.attribute.title': 'Titel',
  'criteria.attribute.tag': 'Tag',
  'criteria.attribute.tendered': 'Fertig oder in Review',
  'criteria.attribute.judgment': 'Bewertung',
  'criteria.attribute.cancelled': 'Abgebrochen',
  'criteria.attribute.done': 'Fertig',
  'criteria.value.yes': 'ja',
  'criteria.value.no': 'nein',
  'criteria.value.noneYet': 'noch keine',
  'criteria.value.accepted': 'Abgenommen',
  'criteria.value.denied': 'Abnahme verweigert',
  'criteria.value.doneOrCancelled': 'Fertig oder abgebrochen',
  'criteria.value.unclaimed': 'Noch zu vergeben',
  'criteria.value.noParties': 'Keine Beteiligten',
  'criteria.value.noTag': 'Kein Tag',
  'criteria.value.noGroup': 'Keine Gruppe',
  'criteria.value.noParent': 'Keine übergeordnete Aufgabe',
  'criteria.value.levelAtLeast': '≥ {level}',
  'criteria.value.levelBelow': '< {level}',
  'criteria.value.titleContains': 'enthält „{text}“',
  'criteria.value.titleNotContains': 'enthält {not} „{text}“',
  'criteria.word.not': 'nicht',
  'criteria.value.tag': '#{tag}',
  'criteria.level.info': 'Info',
  'criteria.level.notice': 'Hinweis',
  'criteria.level.warning': 'Warnung',
  'criteria.level.critical': 'kritisch',
  'criteria.chip.is': '{attribute}: {value}',
  'criteria.chip.isNot': '{attribute} ≠ {value}',
  'criteria.chip.contains': '{attribute} enthält {value}',
  'criteria.chip.containsNot': '{attribute} enthält nicht {value}',
  'criteria.chip.levelAtLeast': '{attribute} ≥ {value}',
  'criteria.chip.levelBelow': '{attribute} < {value}',
  'criteria.chip.title': '„{text}“',
  'criteria.chip.not': 'nicht {value}',
  'criteria.chip.or': '{first} oder {second}',
  'criteria.chip.hasTag': 'Mit Tag',
  'criteria.chip.hasContributor': 'Vergeben',
  'criteria.chip.hasParties': 'Mit Beteiligten',
  'criteria.chip.inAGroup': 'In einer Gruppe',
  'criteria.chip.hasParent': 'Mit übergeordneter Aufgabe',
  'criteria.bar.label': 'Filter',
  'criteria.bar.placeholder': 'Filtern…',
  'criteria.bar.removeFilter': 'Filter {label} entfernen',
  'criteria.bar.combine': 'Wie die Filter verknüpft werden',
  'criteria.bar.all': 'alle',
  'criteria.bar.any': 'eine davon',
  'criteria.bar.pending': '{attribute}:',
  'criteria.bar.suggestions': 'Filtervorschläge',
  'criteria.bar.attributeHint': 'Merkmal…',
  'criteria.bar.searchEverywhere': 'Überall suchen',
  'criteria.bar.editTerm': 'Suchbegriff bearbeiten',
  'criteria.bar.exclude': 'Ausschließen',
  'criteria.bar.or': 'Oder',
  'criteria.bar.filters': { one: '{count} Filter', other: '{count} Filter' },
  'criteria.bar.hint': '↵ filtern · {shift}↵ ausschließen · − vor einen Wert setzen',
  'criteria.bar.hintWithOr':
    '↵ filtern · {shift}↵ ausschließen · {alt}↵ oder · − vor einen Wert setzen',
  'criteria.key.shift': 'Umschalt+',
  'criteria.key.alt': 'Alt+',
  'criteria.menu.label': 'Filter {label}',
  'criteria.menu.is': 'ist',
  'criteria.menu.isNot': 'ist nicht',
  'criteria.menu.isAnyOf': 'ist eines von',
  'criteria.menu.isNoneOf': 'ist keines von',
  'criteria.menu.atLeast': 'mindestens',
  'criteria.menu.below': 'unter',
  'criteria.editor.comparison': 'Vergleich',
  'criteria.editor.depth': 'Tiefe',
  'criteria.editor.direct': 'direkt',
  'criteria.editor.indirect': 'auch indirekt',
  'criteria.editor.searchPeople': 'Personen suchen…',
  'criteria.editor.searchGroups': 'Gruppen suchen…',
  'criteria.editor.searchItems': 'Aufgaben suchen…',
  'criteria.editor.searchTags': 'Tags suchen…',
  'criteria.editor.noMatches': 'Keine Treffer.',
  'criteria.pager.previous': 'Vorherige',
  'criteria.pager.next': 'Nächste',
  'criteria.pager.range': '{first}-{last} von {total}',
  'criteria.pager.empty': '0 von {total}',
} as const satisfies AreaCatalog<typeof en>;
